export const THEMES = [
  {
    id: 'blue',
    label: 'Light Blue',
    swatch: '#4285F4',
    palette: ['#174ea6', '#4285f4', '#e8f0fe', '#8ab4f8', '#d2e3fc'],
  },
  {
    id: 'green',
    label: 'Green',
    swatch: '#0f9d58',
    palette: ['#0d652d', '#0f9d58', '#e6f4ea', '#81c995', '#ceead6'],
  },
  {
    id: 'purple',
    label: 'Purple',
    swatch: '#a855f7',
    palette: ['#4A2C6E', '#A855F7', '#160E22', '#C084FC', '#E9D5FF'],
  },
  {
    id: 'gold',
    label: 'Gold',
    swatch: '#f4b400',
    palette: ['#e27200', '#f4b400', '#fef7e0', '#fde293', '#fef0b2'],
  },
]

export default {
  THEMES,
}
